"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersList = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_element_1 = require("client/components/kpi-header/kpi-element");
const kpi_element_group_1 = require("client/components/kpi-header/kpi-element-group");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui"); // B-106
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Publish_1 = require("material-ui-icons/Publish");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment-timezone");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const order_1 = require("shared/order");
const permissions_1 = require("shared/permissions");
const throttle_debounce_1 = require("throttle-debounce");
const claims_list_1 = require("./components/claims-list");
require("./orders-list.less");
const greenElement = {
    color: kpi_element_1.KPIElementColor.Green,
    label: "Ready to Dispense",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
const redElement = {
    color: kpi_element_1.KPIElementColor.Red,
    label: "Patients for Review",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
const yellowElement = {
    color: kpi_element_1.KPIElementColor.Yellow,
    label: "Pending Adjudication",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
// E-058.1
const lightRedElement = {
    color: kpi_element_1.KPIElementColor.LightRed,
    label: "Queued Schedules",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
let OrdersList = class OrdersList extends react_1.Component {
    constructor() {
        super(...arguments);
        this._isMounted = false;
        this.isFirstMounted = false; // C-097 claim prevent pagination 25 dec isFirstMounted
        this.clickedElement = "";
        this.filterText = "";
        this.filterDate = "";
        this.order = "ASC";
        this.orderBy = "statusPriority.priority";
        // public orderBy = "order.status";
        this.sortMenu = false;
        this.showUpload = false;
        this.showPendingModal = false;
        this.selectedPharm = "0";
        this.selectedProvider = "0";
        this.newProvider = "0";
        this.selectedDate = "0";
        this.selectedAction = "0";
        this.rawCountError = 0;
        this.rawCountPending = 0;
        this.rawCountReady = 0;
        this.availablePharmacies = [];
        this.availableProviders = [];
        this.allProviders = [];
        this.availableDates = [];
        this.onLoadBulkOrder = true; // B-106
        // For pagination // C-097 claims
        this.page = 1;
        this.limit = 100; // C-110
        this.totalPages = 1;
        this.loadOrders = throttle_debounce_1.debounce(200, (showLoading) => {
            const searchDate = this.filterDate;
            // const searchDate =
            //   this.filterDate === "" ? "" : new Date(this.filterDate).toDateString();
            const options = {
                clickedElement: this.clickedElement,
                count: 100,
                order: this.order,
                sort: this.orderBy,
                search: this.filterText,
                searchDate,
                showCompleted: store_1.ordersStore.showCompleted.toString(),
                start: 0,
                // type: Number(ordersStore.paymentToggle)
                type: store_1.ordersStore.paymentToggle ? 1 : 0,
                page: this.page,
                limit: this.limit // C-097 Claims
            };
            store_1.ordersStore.loadOrders(options, showLoading);
        });
        this.handleClickKPIElement = (element) => {
            this.clickedElement =
                this.clickedElement === element.color ? "" : element.color;
            if (!store_3.usersStore.permissions.ReadErrors && this.clickedElement === "red") {
                router_1.RouteManager.transitionTo("/claims/queue");
            }
            else {
                this.page = 1; // C-097 claim to load 1st page
                this.loadOrders(true); // C-097 claim loading true
            }
            // E-058.1
            if (this.clickedElement === "lightred") {
                router_1.RouteManager.transitionTo("/claims/queue");
            }
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            console.log("this.orderBy", this.orderBy, this.order);
            this.loadOrders(true); // C-097 claim loading true
        };
        this.onMouseEnter = () => {
            this.showUpload = true;
        };
        this.onMouseLeave = () => {
            this.showUpload = false;
        };
        this.onCallback = (value, date) => {
            this.filterText = value;
            this.filterDate = date;
            this.loadOrders(true); // C-097 claim loading true
        };
        // C-097 claim
        this.previousPaginationPage = () => {
            if (store_1.ordersStore.currentPage === 1)
                return;
            this.isFirstMounted = true; // C-097 claim prevent pagination 25 dec isFirstMounted
            this.page = this.page - 1,
                this.limit = this.limit;
            this.loadOrders(true); // C-097 claim loading true
        };
        // C-097 claim
        this.nextPaginationPage = () => {
            if (store_1.ordersStore.currentPage >= store_1.ordersStore.totalProviderPage)
                return;
            this.isFirstMounted = true; // C-097 claim prevent pagination 25 dec isFirstMounted
            this.page = this.page + 1,
                this.limit = this.limit;
            this.loadOrders(true); // C-097 claim loading true
        };
        // C-097 claim
        this.selectPaginationPage = (page) => {
            this.page = 1,
                this.limit = page,
                this.loadOrders(true); // C-097 claim loading true
        };
        // input functionalty
        this.handleKeyDownInput = (data) => {
            if (data === Number(""))
                return;
            this.page = data;
            this.loadOrders(true);
        };
        this.filterCount = () => {
            if (!store_1.ordersStore.count || !store_1.ordersStore.count.value) {
                return;
            }
            let rawCount = store_1.ordersStore.count.value.actionRequiredCount;
            let rawCountPending = store_1.ordersStore.count.value.pendingCount;
            let rawCountReady = store_1.ordersStore.count.value.readyCount;
            // console.log("count =====", rawCount);
            let { orders: { value: orders = [] } } = store_1.ordersStore;
            if (!store_3.usersStore.permissions.ReadErrors) {
                orders = orders.filter(order => !(order.status === order_1.OrderStatus.Error ||
                    order.status === order_1.OrderStatus.ReverseError));
            }
            const isUserProvider = store_3.usersStore.userProvider &&
                store_3.usersStore.userProvider.value &&
                store_3.usersStore.userProvider.value.userId === store_3.usersStore.user.value.id &&
                store_3.usersStore.user.value.siteUser &&
                !store_3.usersStore.user.value.siteAdmin;
            for (const row of orders) {
                console.log("Order row confirmation:", { row });
                const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
                const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
                const isError = row.status === order_1.OrderStatus.Error;
                const noneApprovedMsg = row.message.toLowerCase() === "no claims approved";
                const clinicErrorMessage = isError && noneApprovedMsg ? "None Approved" : "Out of Network";
                const isNotApproved = clinicErrorMessage === "None Approved";
                const isDev = store_3.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
                let statusText = "Claim Status"; // This should never show up.
                switch (row.status) {
                    case order_1.OrderStatus.Ready:
                        statusText = auditUnsubmitted
                            ? "Ready for Provider Review"
                            : auditPending
                                ? "Approved to Dispense"
                                : "Ready To Dispense";
                        break;
                    case order_1.OrderStatus.Pending:
                        statusText = "Pending Adjudication";
                        break;
                    case order_1.OrderStatus.Intended:
                        statusText = "Intend to Dispense";
                        break;
                    case order_1.OrderStatus.Progress:
                    case order_1.OrderStatus.Executing:
                        statusText = "In Progress";
                        break;
                    case order_1.OrderStatus.Reversing:
                        statusText = "Canceling";
                        break;
                    case order_1.OrderStatus.Reversed:
                        statusText = "Canceled";
                        break;
                    case order_1.OrderStatus.Error:
                        statusText = store_3.usersStore.permissions.ReadErrors
                            ? row.refill
                                ? "Refill Error"
                                : isNotApproved
                                    ? "Ready to Cancel"
                                    : "Error"
                            : clinicErrorMessage;
                        break;
                    case order_1.OrderStatus.ReverseError:
                        statusText = isDev ? "Failed to Reverse" : "Pending Reversal";
                        break;
                    case order_1.OrderStatus.Refill:
                        statusText = "Refill Due";
                        break;
                    default:
                        statusText = "Dispensed";
                        break;
                }
                if (statusText === "None Approved")
                    row.status = order_1.OrderStatus.Reversed;
                const readFailures = store_3.usersStore.permissions.ReadFailures;
                if (!readFailures &&
                    (statusText === "Error" ||
                        statusText === "Failed to Reverse" ||
                        statusText === "Pending Reversal")) {
                    rawCount--;
                    store_1.ordersStore.userViewCount = rawCount;
                }
                if (isUserProvider) {
                    if (row.provider.userId !== store_3.usersStore.user.value.id) {
                        if (row.status === order_1.OrderStatus.Ready) {
                            rawCountReady--;
                        }
                        if (readFailures &&
                            (statusText === "Error" ||
                                statusText === "Failed to Reverse" ||
                                statusText === "Pending Reversal")) {
                            store_1.ordersStore.count.value.actionRequiredCount--;
                            rawCount--;
                            store_1.ordersStore.userViewCount = rawCount;
                        }
                        if (statusText === "Pending Adjudication" ||
                            statusText === "In Progress") {
                            rawCountPending--;
                        }
                    }
                }
            }
            this.rawCountError = rawCount;
            this.rawCountPending = rawCountPending;
            this.rawCountReady = rawCountReady;
            // return rawCount;
        };
        this.renderKPIElement = (el) => {
            const counts = store_1.ordersStore.count.value;
            const queueLength = store_1.ordersStore.submissionQueueLength;
            let realCount = 0;
            if (counts) {
                realCount = store_1.ordersStore.userViewCount;
            }
            let value;
            switch (el.color) {
                case "green":
                    value = this.rawCountReady;
                    break;
                case "red":
                    if (store_3.usersStore.permissions.ReadErrors) {
                        value = store_3.usersStore.permissions.ReadFailures
                            ? this.rawCountError || realCount
                            : realCount;
                    }
                    else {
                        value = queueLength;
                    }
                    break;
                case "yellow":
                    value = this.rawCountPending;
                    break;
                case "lightred": // E-058.1
                    if (store_3.usersStore.permissions.ReadAudit) {
                        value = store_1.ordersStore === null || store_1.ordersStore === void 0 ? void 0 : store_1.ordersStore.submissionQueueLength;
                    }
                    else {
                        value = store_1.ordersStore === null || store_1.ordersStore === void 0 ? void 0 : store_1.ordersStore.submissionQueueLength;
                    }
                    break;
                default:
                    value = 0;
            }
            if (value === null)
                value = 0;
            const element = ramda_1.merge(el, { value });
            return (React.createElement(kpi_element_1.KpiElement, { check: element.color === kpi_element_1.KPIElementColor.Red && value === 0, faded: this.clickedElement !== "" && this.clickedElement !== element.color, element: element, onClickElement: this.handleClickKPIElement }));
        };
        /**
         * B-106 add this function to handle to open the confirmation modal
         * popup and fetch the bulk orders API to get orders
        */
        this.handleBulkTaskEle = async () => {
            this.onLoadBulkOrder = false;
            this.showPendingModal = true;
            const searchDate = this.filterDate;
            const options = {
                showCompleted: store_1.ordersStore.showCompleted.toString(),
                searchDate,
                type: store_1.ordersStore.paymentToggle ? 1 : 0
            };
            await store_1.ordersStore.loadBulkOrders(options);
            this.onLoadBulkOrder = true;
        };
        this.renderLoadingIndicator = () => (React.createElement("div", { className: "orders-list__loading-indicator" },
            React.createElement("div", null, "Loading completed claims")));
        this.countOrders = () => {
            const options = {
                type: store_1.ordersStore.paymentToggle ? 1 : 0
            };
            store_1.ordersStore.countOrder(options);
        };
        this.handlePaymentToggle = () => {
            store_1.ordersStore.paymentToggle = !store_1.ordersStore.paymentToggle;
            this.loadOrders(true);
            this.countOrders();
        };
        this.handleToggle = () => {
            store_1.ordersStore.showCompleted = !store_1.ordersStore.showCompleted;
            this.loadOrders(true);
        };
    }
    async componentDidMount() {
        this._isMounted = true;
        this.isFirstMounted = true; // C-097 claim prevent pagination 25 dec isFirstMounted
        this.loadOrders(true); // C-097 claim loading true
        this.countOrders();
        await store_1.ordersStore.getQueueCount();
        // C-097 Claims
        this.totalPages = store_1.ordersStore.totalProviderPage;
        window.clearInterval(this.loadOrderInterval);
        this.loadOrderInterval = window.setInterval(() => {
            // @tkay added condition based on value of this._isMounted
            if (this._isMounted && store_1.ordersStore.currentPage === 1 && !store_1.ordersStore.orders.loading) { // C-097 setInterval Ayush // C-097 claim prevent pagination 25 dec isFirstMounted
                this.countOrders();
                this.loadOrders(true); // C-097 claim loading true
                this.isFirstMounted = false; // C-097 claim prevent pagination 25 dec isFirstMounted
            }
        }, 10000);
        // }, 2500);
    }
    componentWillUnmount() {
        this._isMounted = false; // @tkay added in attempt to fix memory leak.
        window.clearInterval(this.loadOrderInterval);
    }
    componentDidUpdate() {
        this.filterCount();
        ReactTooltip.rebuild();
    }
    render() {
        return (React.createElement("div", { className: "orders-list custOrderList orderList-wrapper" },
            (this.showPendingModal && this.renderPendingModal()) || "",
            store_3.usersStore.permissions.ReadClaims ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "kpiBanner" },
                    React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true, decoration: {
                            type: 'fixed', top: 64, zIndex: 55, width: '-webkit-fill-available'
                        } },
                        React.createElement("div", { className: "orders-list__title-wrapper" },
                            React.createElement(kpi_title_1.KpiTitle, { label: "Claims" }),
                            store_3.usersStore.permissions.CreateClaims && (React.createElement("div", { className: "floating-buttons", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, tabIndex: 0 },
                                React.createElement(button_1.MaterialButton, { fab: true, secondary: true, className: "import-order-btn", onClick: () => store_1.ordersStore.reset(), to: "/claims/submit" },
                                    React.createElement(Publish_1.default, null)),
                                React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-order-btn", to: "/claims/new", onMouseEnter: this.onMouseEnter },
                                    React.createElement(Add_1.default, null))))),
                        this.renderKPIElementGroup())),
                React.createElement(ui_1.UiForm, { loading: store_1.ordersStore.orders.loading },
                    React.createElement(floating_page_1.FloatingPage, null,
                        React.createElement(claims_list_1.ClaimsList, { order: this.order, orderBy: this.orderBy, onRequestSort: this.onRequestSort, onFilterChange: this.onCallback, switchLabel2: store_1.ordersStore.paymentLabel, filterText: this.filterText, filterDate: this.filterDate, switchChecked: store_1.ordersStore.showCompleted, switchChecked2: store_1.ordersStore.paymentToggle, toggleShowCompleted: this.handleToggle, toggleShowPaidCash: this.handlePaymentToggle, withSwitch: true, withSwitch2: true, page: this.page, limit: this.limit, clickNext: this.nextPaginationPage, clickPrevious: this.previousPaginationPage, clickSelectDropdown: this.selectPaginationPage, handleKeyDown: this.handleKeyDownInput })),
                    store_1.ordersStore.showCompleted &&
                        store_1.ordersStore.orders.loading &&
                        this.renderLoadingIndicator(),
                    React.createElement(ReactTooltip, { effect: "solid", place: "left" })))) : (store_3.usersStore.showLock())));
    }
    async handleSelection(type, id) {
        if (type === "selectedAction") {
            this.selectedDate = "0";
            this.selectedPharm = "0";
            this.newProvider = "0";
            this.selectedProvider = "0";
        }
        if (type === "selectedPharm") {
            this.newProvider = "0";
            this.selectedProvider = "0";
        }
        const originalPharm = this.selectedPharm;
        const strId = String(id);
        this[type] = strId;
        const updateProvider = this.selectedAction === "2" && this.selectedPharm !== originalPharm;
        if (updateProvider) {
            await store_2.sitesDetailStore.loadProviders({
                id: Number(id),
                order: "ASC"
            });
            this.allProviders = store_2.sitesDetailStore.providers.value.map((provider, i) => {
                const providerName = `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix}`;
                return {
                    id: provider.id,
                    label: providerName,
                    value: provider.id
                };
            });
            this.forceUpdate();
        }
    }
    renderPendingModal() {
        const { bulkOrders: { value: bulkOrders = [] } } = store_1.ordersStore;
        // B-106
        // 0: Run Pending
        // 1: Mass Reverse
        // 2: Change Provider
        // 3: Mass Cancel Pending
        const usesPending = ["0", "2", "3"].includes(this.selectedAction);
        const pullStatuses = usesPending
            ? [order_1.OrderStatus.Pending]
            : [order_1.OrderStatus.Error, order_1.OrderStatus.Ready];
        const availableClaims = bulkOrders.filter((order) => pullStatuses.includes(order.status)); // B-106
        const uniques = [];
        this.availablePharmacies = availableClaims
            .map((order) => {
            if (uniques.includes(order.site.id))
                return;
            uniques.push(order.site.id);
            return {
                id: order.site.id,
                label: order.site.name,
                value: order.site.id
            };
        })
            .filter((site) => !!site);
        this.availableDates = availableClaims
            .map((order, i) => {
            const date = moment(order.createDate).format("MM-DD-YYYY");
            if (uniques.includes(date))
                return;
            uniques.push(date);
            return {
                id: i + 1,
                label: date,
                value: date
            };
        })
            .filter((date) => !!date);
        this.availableProviders = availableClaims
            .map((order, i) => {
            const provider = `${order.provider.prefix} ${order.provider.firstName} ${order.provider.lastName} ${order.provider.suffix}`;
            if (uniques.includes(provider))
                return;
            uniques.push(provider);
            return {
                id: order.provider.id,
                label: provider,
                value: order.provider.id
            };
        })
            .filter((provider) => !!provider);
        this.availablePharmacies.unshift({
            id: 0,
            label: "All Pharmacies",
            value: 0
        });
        this.availableDates.unshift({
            id: 0,
            label: "All Dates",
            value: 0
        });
        const selections = () => {
            const actions = [
                "Run Pending",
                "Mass Reverse",
                "Update Provider",
                "Cancel Pending"
            ].map((label, i) => ({ id: i, label, value: String(i) }));
            const showProviders = this.selectedAction === "2" && this.selectedPharm !== "0";
            return (React.createElement(React.Fragment, null,
                this.onLoadBulkOrder && ( // B-106
                React.createElement(React.Fragment, null,
                    React.createElement(select_1.MaterialSelect, { options: actions, required: true, label: "Action", onSelect: e => this.handleSelection("selectedAction", e), value: this.selectedAction }),
                    React.createElement("br", null),
                    React.createElement(select_1.MaterialSelect, { options: this.availablePharmacies, required: true, searchable: true, label: "By Pharmacy", onSelect: e => this.handleSelection("selectedPharm", e), value: this.selectedPharm }),
                    React.createElement("br", null),
                    React.createElement(select_1.MaterialSelect, { options: this.availableDates, required: true, searchable: true, label: "By Date", onSelect: e => this.handleSelection("selectedDate", e), value: this.selectedDate }),
                    showProviders ? (React.createElement(React.Fragment, null,
                        React.createElement("br", null),
                        React.createElement(select_1.MaterialSelect, { options: this.availableProviders, required: true, searchable: true, label: "Original Physician", onSelect: e => this.handleSelection("selectedProvider", e), value: this.selectedProvider }),
                        React.createElement("br", null),
                        React.createElement(select_1.MaterialSelect, { options: this.allProviders, required: true, searchable: true, label: "New Physician", onSelect: e => this.handleSelection("newProvider", e), value: this.newProvider }))) : (React.createElement(React.Fragment, null)))),
                !this.onLoadBulkOrder && ( // B-106
                React.createElement("div", { style: { display: 'float' } },
                    React.createElement(ui_1.UiLoadingIndicator, null)))));
        };
        return (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Execute Task", cancelText: this.onLoadBulkOrder ? "Return to Claims" : '', message: ``, onCancel: () => (this.showPendingModal = false), onConfirm: () => this.handleExecuteTask(), addinModal: selections(), title: "Bulk Tasks", shouldDisableConfirm: !this.onLoadBulkOrder }));
    }
    async handleExecuteTask() {
        const { bulkOrders: { value: bulkOrders = [] } } = store_1.ordersStore; // B-106
        const matchingOrders = bulkOrders.filter((order) => {
            const usesPending = ["0", "2", "3"].includes(this.selectedAction);
            const defaultDate = this.selectedDate === "0";
            const defaultPharm = this.selectedPharm === "0";
            const defaultProvider = this.selectedProvider === "0";
            const availableDate = moment(this.selectedDate, "MM-DD-YYYY");
            const providerMatch = defaultProvider
                ? defaultProvider
                : order.provider.id === Number(this.selectedProvider);
            const dateMatch = defaultDate
                ? defaultDate
                : moment(order.createDate).isSame(availableDate, "day");
            const siteMatch = defaultPharm
                ? defaultPharm
                : order.site.id === Number(this.selectedPharm);
            const pullStatuses = usesPending
                ? [order_1.OrderStatus.Pending]
                : [order_1.OrderStatus.Error, order_1.OrderStatus.Ready];
            const statusMatch = pullStatuses.includes(order.status);
            const match = dateMatch && siteMatch && statusMatch && providerMatch;
            return match;
        });
        if (matchingOrders.length === 0) {
            alert("No matching claims found.");
        }
        else if (this.selectedAction === "2" &&
            (this.newProvider === "0" || this.selectedProvider === "0")) {
            alert("Please select a pharmacy, original, and new provider to perform update.");
        }
        else {
            /** This should get modified into a switch if we add anything else. */
            const result = this.selectedAction === "0"
                ? await store_1.ordersStore.runPendingClaims(matchingOrders)
                : this.selectedAction === "1"
                    ? await store_1.ordersStore.setReverse(matchingOrders, "reverse")
                    : this.selectedAction === "2"
                        ? await store_1.ordersStore.updateProvider(matchingOrders, this.newProvider)
                        : await store_1.ordersStore.setReverse(matchingOrders, "cancel");
            if (result) {
                this.showPendingModal = false;
                this.pendingPharms = [];
                this.pendingDates = [];
                this.selectedPharm = "0";
                this.selectedDate = "0";
                alert(`${matchingOrders.length} claims have been ${this.selectedAction === "0"
                    ? "executed"
                    : this.selectedAction === "1"
                        ? "flagged for reversal"
                        : this.selectedAction === "2"
                            ? "updated to a new provider"
                            : "cancelled from pending status"}.`);
                this.loadOrders(true); // C-097 claim loading true
            }
            else
                console.log("Uh-oh.");
        }
    }
    renderKPIElementGroup() {
        return (React.createElement("div", { className: "orders-list__kpi" },
            React.createElement("div", { style: { display: "ruby" } }, store_3.usersStore.permissions.ReadRunPending && (React.createElement(button_1.MaterialButton, { className: "audit-btn", secondary: true, style: { whiteSpace: "nowrap", width: "100%" }, onClick: this.handleBulkTaskEle }, "Bulk Tasks"))),
            React.createElement(kpi_element_group_1.KpiElementGroup, { greenElement: greenElement, redElement: redElement, yellowElement: yellowElement, lightRedElement: lightRedElement, renderElement: this.renderKPIElement.bind(this) })));
    }
};
__decorate([
    mobx_1.observable
], OrdersList.prototype, "clickedElement", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "sortMenu", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "showUpload", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "showPendingModal", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "selectedPharm", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "selectedProvider", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "newProvider", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "selectedDate", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "selectedAction", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "rawCountError", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "rawCountPending", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "rawCountReady", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "onLoadBulkOrder", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], OrdersList.prototype, "totalPages", void 0);
OrdersList = __decorate([
    mobx_react_1.observer
], OrdersList);
exports.OrdersList = OrdersList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-list/orders-list.tsx
// module id = 3761
// module chunks = 0